import React, { useEffect, useContext, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Amplify } from "aws-amplify";
// pages
import Home from "../routes/home";
import NotFoundPage from "../routes/notfound";
import SignUp from "../routes/signup";
import Header from "./header";
import Feedback from "../routes/feedback";
import SideMenu from "./sideMenu";
import { appLogger, Http } from "../utils";

// theme
import "../global-styles/global.css";
import Box from "@mui/material/Box";

import { UserContext } from "../context/userContext";
import { UserLoginInfo } from "../types/context";
// import Products from "../routes/products";
import Chatbots from "../routes/chatbots";
import Reports from "../routes/reports";
import AddProducts from "../routes/add-products";
import AddChatbots from "../routes/add-chatbots";
import Dashboard from "../routes/dashboard";
import Users from "../routes/users";
import ManageOrganizations from "../routes/manage-organizations";
import Groups from "../routes/groups";
import Tickets from "../routes/tickets";
import TicketDetailsEmailReply from "../routes/tickets-details-email-reply";
import Topics from "../routes/topics";
import Articles from "../routes/articles";
import Knowledgebase from "../routes/knowledgebase";
import Agent from "../routes/agent-settings";
import TicketsDetails from "../routes/tickets-details";
import ViewTickets from "../routes/view-tickets";
import ViewReviews from "../routes/view-reviews";
import ViewUncategorisedTickets from "../routes/view-uncategorised-tickets";
import Settings from "../routes/settings";
import Email from "../routes/email-settings";
import Zendesk from "../routes/zendesk-settings";
import Jira from "../routes/jira-settings";
import EditOrganizationPage from "../routes/edit-organization";
import {
  OktaConfigDetails,
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_MEMBER,
  ROLE_USER_SUPERADMIN,
} from "../model";
import HomeOkta from "../routes/homeokta";
import Accounts from "../routes/accounts";
import AddAccount from "../routes/add-account";
import PlayGroundChat from "../routes/playground-chat";
import AutoAssign from "../routes/autoassign-settings";

// import PrivateRoute from "../utils/routings";

// interface CuvoProps {}

const CuvoMain = () => {
  const {
    userInfo,
    isAuthenticated,
    setOrgId,
    setLoginInfo,
    setEnabledFeatures,
  } = useContext(UserContext) as UserLoginInfo;
  const [IsOrgCompleted, setIsOrgCompleted] = useState(false);
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin), {
      replace: true,
    });
  };
  const [oktaAuth, setOktaAuth] = useState<any>();
  const [oktaDetails, setOktaDetails] = useState({
    clientId: "",
    issuer: "",
    redirectUri: "",
  });
  const [ssoEnabled, setSsoEnabled] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  appLogger.info({
    infoObj: {
      method: "CuvoMain",
      component: "components",
      fileName: "app.tsx",
      userInfo: userInfo,
      isAuthenticated: isAuthenticated,
    },
  });

  // Amplify.configure({
  //   aws_cognito_region: systemInfo.userpoolRegion,
  //   aws_user_pools_id: systemInfo.userpoolId,
  //   aws_user_pools_web_client_id: systemInfo.appClientId,
  // });
  // {!isAuthenticated && (
  //   <Routes>
  //     <Route path="/" element={<Home type="authentication" />} />
  //   </Routes>
  // )}
  // {!isAuthenticated && (
  //   <Routes>
  //     <Route path="/" element={<Home type="authentication" />} />
  //   </Routes>
  // )}
  const token = localStorage.getItem("authToken");
  useEffect(() => {
    if ((token == "" || token === null) && location.pathname != "/sign-up") {
      navigate("/");
    }
  }, [token]);

  useEffect(() => {
    // if (typeof window !== "undefined") {
    if (isAuthenticated && userInfo.accessToken && userInfo.idToken) {
      return;
    }
    setIsloading(true);
    Http.get({
      url: "/api/v2/organizations/0",
      customHeaders: { noauthvalidate: "true" },
    })
      .then((response: any) => {
        // const user = response.systemUser;
        // const pwd = response.systemPassword;
        appLogger.info({
          infoObj: {
            method: "useEffect",
            component: "components",
            fileName: "app.tsx",
            orgCognito: response.organizationDetails.cognito,
          },
        });
        let cognito = {
          appClientId: "",
          appClientURL: "",
          userpoolId: "",
          userpoolRegion: "",
        };
        let okta: OktaConfigDetails = {
          clientId: "",
          issuer: "",
          apiUrl: "",
          apiKey: "",
          groupRoleMap: {},
        };

        if (
          response.organizationDetails.ssoEnabled &&
          response.organizationDetails.okta
        ) {
          setIsOrgCompleted(true);
          okta = response.organizationDetails.okta;
          setOktaDetails({
            clientId: response.organizationDetails.okta.clientId,
            issuer: response.organizationDetails.okta.issuer,
            redirectUri: window.location.origin + "/login/callback",
          });
          const oktaAuthVar = new OktaAuth({
            clientId: response.organizationDetails.okta.clientId,
            issuer: response.organizationDetails.okta.issuer,
            redirectUri: window.location.origin + "/login/callback",
          });
          setOktaAuth(oktaAuthVar);
          setSsoEnabled(true);
        }
        if (response.organizationDetails.cognito) {
          cognito = {
            appClientId: response.organizationDetails.cognito.appClientId,
            appClientURL: response.organizationDetails.cognito.appClientURL,
            userpoolId: response.organizationDetails.cognito.userpoolId,
            userpoolRegion: response.organizationDetails.cognito.userpoolRegion,
          };
        }

        if (
          response?.organizationDetails?.enabledFeatures &&
          Object.keys(response.organizationDetails.enabledFeatures).length > 0
        ) {
          const { enabledFeatures } = response.organizationDetails;
          setEnabledFeatures(enabledFeatures);
        }
        setLoginInfo({
          cognito,
          okta,
        });
        appLogger.info({
          infoObj: {
            method: "useEffect",
            component: "components",
            fileName: "app.tsx",
          },
        });
        setOrgId(response.organizationDetails.orgId);
        Amplify.configure({
          aws_cognito_region:
            response.organizationDetails.cognito.userpoolRegion,
          aws_user_pools_id: response.organizationDetails.cognito.userpoolId,
          aws_user_pools_web_client_id:
            response.organizationDetails.cognito.appClientId,
        });
        setIsloading(false);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "useEffect",
            component: "components",
            fileName: "app.tsx",
            err: error,
          },
        });
        setIsloading(false);
      });
    // }
  }, []);
  useEffect(() => {
    const handleStorageChange = (event: any) => {
      if (event.key === "logoutEvent") {
        // Perform your logout logic here
        location.href = "/";
      }
    };
    // Add event listener for the storage event
    window.addEventListener("storage", handleStorageChange);
    return () => {
      // Remove event listener when the component unmounts
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const checkIsOrgCompleted = () => {
    if (
      isAuthenticated &&
      userInfo &&
      userInfo.userDetails &&
      userInfo.userDetails.userRole &&
      userInfo.userDetails.orgId &&
      userInfo.userDetails.orgId != ""
    ) {
      setIsOrgCompleted(true);
      return true;
    }
    return false;
  };
  const renderSidebar = () => {
    return (
      <>
        <SideMenu />
        <Box component="main">
          {userInfo &&
            userInfo.userDetails &&
            userInfo.userDetails.userRole &&
            userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN && (
              <Routes>
                {/* <Route path="/" element={<Navigate to="feedback" replace />} /> */}
                <Route
                  path="/"
                  element={
                    token != "" ? (
                      <Navigate to="dashboard" replace />
                    ) : (
                      <Home type="authentication" />
                    )
                  }
                />
                {/* <Route path="/products" element={<Products />} /> */}
                <Route path="/chatbots" element={<Chatbots />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/add-product" element={<AddProducts />} />
                <Route path="/add-account" element={<AddAccount />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route
                  path="/manage-organizations"
                  element={<ManageOrganizations />}
                />
                <Route
                  path="/edit-organization/:id"
                  element={<EditOrganizationPage />}
                />
                <Route path="/groups" element={<Groups />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route
                  path="/:pagetype/tickets-reply/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />
                <Route
                  path="/:pagetype/tickets-details/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />

                <Route path="/topics" element={<Topics />} />
                <Route path="/articles" element={<Articles />} />

                <Route
                  path="/knowledgebase-settings/:productId/:versionId"
                  element={<Knowledgebase />}
                />
                <Route
                  path="/chat-settings/:productId/:versionId"
                  element={<AddChatbots />}
                />
                <Route
                  path="/agent-settings/:productId/:versionId"
                  element={<Agent />}
                />
                <Route
                  path="/email-settings/:productId/:versionId"
                  element={<Email />}
                />
                <Route
                  path="/autoassign-settings/:productId/:versionId"
                  element={<AutoAssign />}
                />
                <Route
                  path="/zendesk-settings/:productId/:versionId"
                  element={<Zendesk />}
                />
                <Route
                  path="/jira-settings/:productId/:versionId"
                  element={<Jira />}
                />
                <Route path="/view-tickets/:id" element={<ViewTickets />} />
                <Route path="/view-reviews/:id" element={<ViewReviews />} />

                <Route
                  path="/view-uncategorized-ticket"
                  element={<ViewUncategorisedTickets />}
                />

                <Route path="/tickets-details" element={<TicketsDetails />} />
                <Route
                  path="/tickets-details/:id"
                  element={<TicketsDetails />}
                />
                <Route path="/playground-chat" element={<PlayGroundChat />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            )}
          {userInfo &&
            userInfo.userDetails &&
            userInfo.userDetails.userRole &&
            userInfo.userDetails.userRole === ROLE_USER_ADMIN && (
              <Routes>
                {/* <Route path="/" element={<Navigate to="feedback" replace />} /> */}
                <Route
                  path="/"
                  element={
                    token != "" ? (
                      <Navigate to="dashboard" replace />
                    ) : (
                      <Home type="authentication" />
                    )
                  }
                />
                {/* <Route path="/products" element={<Products />} /> */}
                <Route path="/chatbots" element={<Chatbots />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/add-product" element={<AddProducts />} />
                <Route path="/add-account" element={<AddAccount />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                {/* <Route
                  path="/manage-organizations"
                  element={<ManageOrganizations />}
                />
                <Route
                  path="/edit-organization/:id"
                  element={<EditOrganizationPage />}
                /> */}
                <Route path="/groups" element={<Groups />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route
                  path="/:pagetype/tickets-reply/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />
                <Route
                  path="/:pagetype/tickets-details/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />

                <Route path="/topics" element={<Topics />} />
                <Route path="/articles" element={<Articles />} />

                <Route
                  path="/knowledgebase-settings/:productId/:versionId"
                  element={<Knowledgebase />}
                />
                <Route
                  path="/chat-settings/:productId/:versionId"
                  element={<AddChatbots />}
                />
                <Route
                  path="/agent-settings/:productId/:versionId"
                  element={<Agent />}
                />
                <Route
                  path="/email-settings/:productId/:versionId"
                  element={<Email />}
                />
                <Route
                  path="/autoassign-settings/:productId/:versionId"
                  element={<AutoAssign />}
                />
                <Route
                  path="/zendesk-settings/:productId/:versionId"
                  element={<Zendesk />}
                />
                <Route
                  path="/jira-settings/:productId/:versionId"
                  element={<Jira />}
                />
                <Route path="/view-tickets/:id" element={<ViewTickets />} />
                <Route path="/view-reviews/:id" element={<ViewReviews />} />

                <Route
                  path="/view-uncategorized-ticket"
                  element={<ViewUncategorisedTickets />}
                />

                <Route path="/tickets-details" element={<TicketsDetails />} />
                <Route
                  path="/tickets-details/:id"
                  element={<TicketsDetails />}
                />
                <Route path="/playground-chat" element={<PlayGroundChat />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            )}
          {userInfo &&
            userInfo.userDetails &&
            userInfo.userDetails.userRole &&
            userInfo.userDetails.userRole === ROLE_USER_MANAGER && (
              <Routes>
                <Route path="/" element={<Navigate to="feedback" replace />} />
                {/* <Route path="/products" element={<Products />} /> */}
                <Route path="/chatbots" element={<Chatbots />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/add-product" element={<AddProducts />} />
                <Route path="/add-account" element={<AddAccount />} />
                <Route path="/add-chatbots" element={<AddChatbots />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                {/* <Route
                  path="/manage-organizations"
                  element={<ManageOrganizations />}
                />
                <Route
                  path="/edit-organization/:id"
                  element={<EditOrganizationPage />}
                /> */}
                <Route path="/tickets" element={<Tickets />} />
                <Route
                  path="/:pagetype/tickets-reply/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />

                <Route
                  path="/:pagetype/tickets-details/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />
                <Route path="/topics" element={<Topics />} />
                <Route path="/articles" element={<Articles />} />

                <Route
                  path="/knowledgebase-settings/:productId/:versionId"
                  element={<Knowledgebase />}
                />
                <Route
                  path="/chat-settings/:productId/:versionId"
                  element={<AddChatbots />}
                />
                <Route
                  path="/agent-settings/:productId/:versionId"
                  element={<Agent />}
                />
                <Route
                  path="/email-settings/:productId/:versionId"
                  element={<Email />}
                />
                <Route
                  path="/autoassign-settings/:productId/:versionId"
                  element={<AutoAssign />}
                />
                <Route
                  path="/zendesk-settings/:productId/:versionId"
                  element={<Zendesk />}
                />
                <Route
                  path="/jira-settings/:productId/:versionId"
                  element={<Jira />}
                />
                <Route path="/view-tickets/:id" element={<ViewTickets />} />
                <Route path="/view-reviews/:id" element={<ViewReviews />} />

                <Route
                  path="/view-uncategorized-ticket"
                  element={<ViewUncategorisedTickets />}
                />

                <Route path="/tickets-details" element={<TicketsDetails />} />
                <Route
                  path="/tickets-details/:id"
                  element={<TicketsDetails />}
                />
                <Route path="/playground-chat" element={<PlayGroundChat />} />

                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            )}
          {userInfo &&
            userInfo.userDetails &&
            userInfo.userDetails.userRole &&
            userInfo.userDetails.userRole === ROLE_USER_MEMBER && (
              <Routes>
                <Route path="/" element={<Navigate to="feedback" replace />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route
                  path="/:pagetype/tickets-reply/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />
                <Route
                  path="/:pagetype/tickets-details/:ticketId"
                  element={<TicketDetailsEmailReply />}
                />
                <Route path="/topics" element={<Topics />} />
                <Route path="/articles" element={<Articles />} />

                <Route path="/tickets-details" element={<TicketsDetails />} />
                <Route path="/view-tickets/:id" element={<ViewTickets />} />
                <Route path="/view-reviews/:id" element={<ViewReviews />} />

                <Route
                  path="/view-uncategorized-ticket"
                  element={<ViewUncategorisedTickets />}
                />

                <Route
                  path="/tickets-details/:id"
                  element={<TicketsDetails />}
                />
                <Route path="/playground-chat" element={<PlayGroundChat />} />

                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            )}
        </Box>
      </>
    );
  };
  const renderHome = () => {
    return (
      <>
        <Box component="main">
          <Home type="OrgCompleted" setIsOrgCompleted={setIsOrgCompleted} />
        </Box>
      </>
    );
  };
  if (isAuthenticated && location.pathname == "/sign-up") {
    return (
      <Box className={isLoading ? "content-wrap loader" : "content-wrap"}>
        <Box component="main">
          <Routes>
            <Route path="/sign-up" element={<SignUp />} />
          </Routes>
        </Box>
      </Box>
    );
  }
  if (isAuthenticated && ssoEnabled && oktaDetails.clientId && oktaAuth) {
    return (
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        {isAuthenticated && <Header {...userInfo} />}
        <Box className="content-wrap">{renderSidebar()}</Box>
      </Security>
    );
  }

  if (isAuthenticated) {
    if (IsOrgCompleted) {
      return (
        <div>
          {isAuthenticated && <Header {...userInfo} />}
          <Box className="content-wrap">{renderSidebar()}</Box>
        </div>
      );
    }
    return (
      <div>
        {isAuthenticated && <Header {...userInfo} />}
        <Box className="content-wrap">
          {checkIsOrgCompleted() ? renderSidebar() : renderHome()}
        </Box>
      </div>
    );
  }
  if (ssoEnabled && oktaDetails.clientId && oktaAuth) {
    return (
      <Box className="content-wrap">
        <Box component="main">
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Routes>
              <Route path="/" element={<HomeOkta />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/login/callback" element={<LoginCallback />} />
            </Routes>
          </Security>
        </Box>
      </Box>
    );
  }
  return (
    <Box className={isLoading ? "content-wrap loader" : "content-wrap"}>
      <Box component="main">
        <Routes>
          {(token === null || token == "") && (
            <Route path="/" element={<Home type="authentication" />} />
          )}
          <Route path="/sign-up" element={<SignUp />} />
        </Routes>
      </Box>
    </Box>
  );
};

const Cuvo = () => {
  return (
    <BrowserRouter>
      <CuvoMain />
    </BrowserRouter>
  );
};

export default Cuvo;
